module.exports = __webpack_public_path__ + "static/media/r_dot_18.3116cee4.png";